import { __assign } from "tslib";
import React from 'react';
export var Leaf = function (_a) {
    var attributes = _a.attributes, children = _a.children, leaf = _a.leaf;
    var color = leaf.color, fontFamily = leaf.fontFamily, fontSize = leaf.fontSize, bold = leaf.bold, italic = leaf.italic, underline = leaf.underline, backgroundColor = leaf.backgroundColor;
    var style = {
        color: color,
        backgroundColor: backgroundColor ? backgroundColor : '#00000000',
        fontFamily: fontFamily ? fontFamily : 'FormaDJRTextRegularTesting',
        fontSize: fontSize ? "".concat(fontSize / 10, "rem") : undefined,
        fontWeight: bold ? 'bold' : 'normal',
        fontStyle: italic ? 'italic' : 'normal',
        textDecoration: underline ? 'underline' : 'none'
    };
    return (React.createElement("span", __assign({ style: style }, attributes), children));
};
//# sourceMappingURL=Mark.js.map